import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './poNotFoundModal.css';
// import declineShipmentModal from '../../src/assets/images/declineShipmentModal.png';
import acceptShipmentModal from '../../../src/assets/images/acceptShipment.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import InputBase from '@mui/material/InputBase';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const PoNotFoundModal = ({isOpen, onClose, linkAutoGeneratedOrder}) => {

  const [isNoChecked, setIsNoChecked] = useState(false);
  const [isYesChecked, setIsYesChecked] = useState(false);  
 
  const handleClose = () => {
    onClose(true);
  };

  const handleChange = () => {
    linkAutoGeneratedOrder(); // Toggle the checkbox value
   }
  

  return (
    <React.Fragment >
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        className='shipmentPoNotFoundModalBody'
       
      >
        <DialogTitle sx={{ m: 0, p: "0px 39px " }} id="customized-dialog-title">
          {/* Modal title */}
              <div className='poNotFoundmodalImagediv'>  
                <img 
                  className='poNotFoundmodalImage'
                  src={acceptShipmentModal}
                />
                <h4 className='headingForPoNotFoundShipmentModal'> PO Not Found </h4>
               
              </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor:"white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            <h4 className='titleHeadingForPoNotFoundModal'>You have not linked a PO to this shipment, do you want to proceed with a system generated PO number?</h4>
            <div>
              <input
                  type="checkbox"
                  checked={isYesChecked} // Bind the checkbox value to the state
                  onChange={handleChange} // Call the function when the checkbox changes
              />
              <span className='checkBox1'>Yes</span>
            </div>
          
            <div>
              <input
                  type="checkbox"
                  checked={isNoChecked} // Bind the checkbox value to the state
                  onChange={handleClose} // Call the function when the checkbox changes
              />
              <span className='checkBox1'>No (No,link to an existing Buyer Purchase order number)</span>
            </div>
            <div>
              <h5 className='subheading1ForPoNotFound'>Please click on EDIT to link existing PO</h5>
            </div>
          </Typography>
        
        </DialogContent>
        <DialogActions>
          <div>
            <h5 className='subheadind2ForPoNotFound'>
            *Once you accept the shipment will be placed.
            </h5>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default PoNotFoundModal;